/* Pitch Signal — minimal interactivity (gallery, quantity, carousels) */
(function () {
  'use strict';

  // Product image gallery: click thumb -> swap main image
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (main && thumb.dataset.full) {
      main.src = thumb.dataset.full;
      main.srcset = '';
    }
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += btn.dataset.qtyStep === 'up' ? 1 : -1;
    input.value = Math.max(parseInt(input.min || '1', 10), val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Download modal (native <dialog>)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-download-open]');
    if (opener) {
      var modal = document.querySelector('[data-download-modal]');
      if (modal && typeof modal.showModal === 'function') {
        e.preventDefault();
        modal.showModal();
      }
      return;
    }
    if (e.target.closest('[data-download-close]')) {
      var dlg = e.target.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    // Click on the backdrop (event target is the dialog itself)
    if (e.target.matches('[data-download-modal]')) {
      e.target.close();
    }
  });

  // Store policy pages are rendered by Shopify (no theme template), so the breadcrumb
  // that every other page gets is added here to match them.
  (function () {
    var policy = document.querySelector('.shopify-policy__container');
    if (!policy || policy.querySelector('.breadcrumb')) return;
    var styleMeta = document.querySelector('meta[name="ps-breadcrumb-style"]');
    var style = styleMeta ? styleMeta.content : 'back';
    if (style === 'none') return;
    var nav = document.createElement('nav');
    nav.className = style === 'full' ? 'breadcrumb' : 'breadcrumb breadcrumb--back';
    nav.setAttribute('aria-label', 'Breadcrumb');
    nav.innerHTML = '<a href="/">Home</a>';
    if (style === 'full') {
      var heading = policy.querySelector('.shopify-policy__title h1');
      nav.innerHTML += '<span class="breadcrumb__sep" aria-hidden="true">\u203a</span>' +
        '<span class="breadcrumb__current" aria-current="page"></span>';
      nav.querySelector('.breadcrumb__current').textContent = heading ? heading.textContent.trim() : document.title;
    }
    policy.insertBefore(nav, policy.firstChild);
  })();

  // "Contact Us" links open the contact popup (sections/contact-toast.liquid) instead
  // of loading the contact page, as long as the popup is on the page.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link || typeof window.contactToastToggle !== 'function') return;
    if (!document.getElementById('contactToastWrap')) return;
    var path = (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
    if (!/\/pages\/contact$/.test(path)) return; // #contact is handled inside the section itself
    e.preventDefault();
    window.contactToastToggle(true);
  });

  // Phone / tablet menu: the button in the header opens the drawer below it.
  function initMobileNav(header) {
    var toggle = header.querySelector('[data-mobile-toggle]');
    var drawer = header.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer || header.hasAttribute('data-mobilenav-ready')) return;
    header.setAttribute('data-mobilenav-ready', '');

    function close() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function () {
      var open = drawer.hidden;
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      // Let the download popup open on its own; any other link closes the drawer.
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) {
        close();
        toggle.focus({ preventScroll: true });
      }
    });
    document.addEventListener('click', function (e) {
      if (!drawer.hidden && !header.contains(e.target)) close();
    });
    window.matchMedia('(min-width: 991px)').addEventListener('change', function (e) {
      if (e.matches) close();
    });
  }
  document.querySelectorAll('.site-header').forEach(initMobileNav);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.site-header').forEach(initMobileNav);
  });

  // Header hover menus (snippets/mega-menu.liquid). Desktop only: a panel opens while
  // the pointer is on its menu item or the panel itself, on keyboard focus, or on first
  // tap on touch screens; hovering a group swaps the product cards. Closes on Escape,
  // leaving the header, hovering another menu item, or clicking elsewhere.
  function initMegaMenus(header) {
    var triggers = header.querySelectorAll('[data-mega-trigger]');
    if (!triggers.length || header.hasAttribute('data-mega-ready')) return;
    header.setAttribute('data-mega-ready', '');

    var desktop = window.matchMedia('(min-width: 991px)');
    var noHover = window.matchMedia('(hover: none)');
    var closeTimer = null;
    var pairs = [];

    function closeAll() {
      clearTimeout(closeTimer);
      pairs.forEach(function (pair) {
        pair.panel.hidden = true;
        pair.trigger.setAttribute('aria-expanded', 'false');
      });
    }
    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 180);
    }
    // Already on the page the menu item points to? Then the panel just covers the
    // same products the visitor is looking at, so leave it closed.
    function isCurrentPage(trigger) {
      if (trigger.getAttribute('aria-current') === 'page') return true;
      try {
        var target = new URL(trigger.getAttribute('href'), window.location.origin);
        var here = window.location.pathname.replace(/\/$/, '');
        return target.pathname.replace(/\/$/, '') === here;
      } catch (e) {
        return false;
      }
    }
    function open(pair) {
      if (!desktop.matches || isCurrentPage(pair.trigger)) return;
      clearTimeout(closeTimer);
      pairs.forEach(function (other) {
        if (other !== pair) {
          other.panel.hidden = true;
          other.trigger.setAttribute('aria-expanded', 'false');
        }
      });
      pair.panel.hidden = false;
      pair.trigger.setAttribute('aria-expanded', 'true');
    }
    function showGroup(panel, id) {
      panel.querySelectorAll('[data-mega-group]').forEach(function (btn) {
        var on = btn.getAttribute('data-mega-group') === id;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-mega-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-mega-panel') !== id;
      });
    }

    triggers.forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var pair = { trigger: trigger, panel: panel };
      pairs.push(pair);

      trigger.addEventListener('mouseenter', function () { open(pair); });
      trigger.addEventListener('focus', function () { open(pair); });
      trigger.addEventListener('click', function (e) {
        // Touch screens have no hover: the first tap opens the panel, a second tap follows the link.
        if (noHover.matches && panel.hidden && desktop.matches) {
          e.preventDefault();
          open(pair);
        }
      });
      panel.addEventListener('mouseenter', function () { open(pair); });

      function pickGroup(e) {
        var btn = e.target.closest('[data-mega-group]');
        if (btn) showGroup(panel, btn.getAttribute('data-mega-group'));
      }
      panel.addEventListener('mouseover', pickGroup);
      panel.addEventListener('focusin', pickGroup);
      panel.addEventListener('click', pickGroup);
    });

    header.addEventListener('mouseleave', closeSoon);
    header.querySelectorAll('.header__nav > a:not([data-mega-trigger]), .header__logo, .header__cart').forEach(function (el) {
      el.addEventListener('mouseenter', closeAll);
    });
    header.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !header.contains(e.relatedTarget)) closeSoon();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openPair = pairs.filter(function (pair) { return !pair.panel.hidden; })[0];
      if (!openPair) return;
      openPair.trigger.focus({ preventScroll: true }); // fires the focus listener (opens), so close afterwards
      closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });
    desktop.addEventListener('change', function () { if (!desktop.matches) closeAll(); });

    // Theme editor: keep the right panel open on the group being edited.
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      pairs.forEach(function (pair) {
        if (pair.panel.querySelector('[data-mega-panel="' + id + '"]')) {
          open(pair);
          showGroup(pair.panel, id);
        } else if (pair.panel.querySelector('[data-mega-block="' + id + '"]')) {
          open(pair);
        }
      });
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      pairs.forEach(function (pair) {
        if (pair.panel.querySelector('[data-mega-panel="' + id + '"], [data-mega-block="' + id + '"]')) closeAll();
      });
    });
  }
  document.querySelectorAll('.site-header').forEach(initMegaMenus);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.site-header').forEach(initMegaMenus);
  });

  // Simple testimonial carousel
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (!track) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        dots.forEach(function (d) { d.removeAttribute('aria-current'); });
        dot.setAttribute('aria-current', 'true');
      });
    });
  });
})();
